import { render, staticRenderFns } from "./MapPassageList.vue?vue&type=template&id=3586177a&scoped=true"
import script from "./MapPassageList.vue?vue&type=script&lang=js"
export * from "./MapPassageList.vue?vue&type=script&lang=js"
import style0 from "./MapPassageList.vue?vue&type=style&index=0&id=3586177a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3586177a",
  null
  
)

export default component.exports